import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
// import { StrtOutcome } from './StrtOutcome';
import { StrtOutcome } from '../../shared/models/plan/StrtOutcome';


@Injectable()
export class OutcomeService {
  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  createOutcome(strategyId: number, outcomes: StrtOutcome[]): Observable<StrtOutcome[]> {
    const initiativeId = outcomes.length ? outcomes[0].initiativeId : undefined;
    return this.http.post<StrtOutcome[]>(this.resourcesUrl(strategyId, initiativeId), outcomes.map(it => it.outcome));
  }

  updateOutcome(strategyId: number, outcome: StrtOutcome): Observable<StrtOutcome> {
    return this.http.put<StrtOutcome>(`${this.resourcesUrl(strategyId, outcome.initiativeId)}/${outcome.outcomeId}`, outcome);
  }

  deleteOutcome(strategyId: number, outcome: StrtOutcome): Observable<{}> {
    return this.http.delete<{}>(`${this.resourcesUrl(strategyId, outcome.initiativeId)}/${outcome.outcomeId}`);
  }

  private resourcesUrl(strategyId: number, initiativeId: number) {
    return `${this.baseUrl}/strategies/${strategyId}/initiatives/${initiativeId}/outcomes`;
  }
}
